import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, Organization } from '../authentication.Service';

@Component({
  selector: 'app-sms-home',
  templateUrl: './sms-home.component.html',
  styleUrls: ['./sms-home.component.css']
})
export class SmsHomeComponent {
  transferType: string = "";
  name: string = "";
  isOrg: boolean = false;
  organization: Organization;
  isOwner: boolean = false;
  isGlobal: boolean = false;
  canEdit: boolean = false;
  isImpersonating: boolean = false;

  constructor(private authService: AuthenticationService,
    private actRoute: ActivatedRoute,
    public router: Router
  ) {
    this.authService.impersonate().subscribe(result => { this.isImpersonating = result != null });
    this.authService.currentOrgRole().subscribe(result => {
      let orgRole = Number(result);
      this.canEdit = orgRole > -1 && orgRole < 2;
    });
    this.authService.getGivenName().subscribe(result => { this.name = result });
    this.authService.currentOrganization().subscribe(result => {
      let i = Number(result);
      this.isOrg = i > 0;
      if (this.isOrg) {
        this.authService.getOrganization(i).subscribe(result => {
          this.organization = result
          this.authService.getUserId().subscribe(result => {
            this.isOwner = this.organization.OwnerId == Number(result);
          });
        });
      }
    });
    if (this.actRoute.snapshot.params.type) {
      switch (this.actRoute.snapshot.params.type) {
        case "keys":
          this.transferType = "keys";
          break;
        case "global":
          this.isGlobal = true;
          break;
      }
    }
  }

  get isBetaTester(): boolean {
    return this.authService.isAuthorized(['beta']);
  }

  networkManager() {
    this.router.navigate(['network']);
  }

  get isAdminUser(): boolean {
    return this.authService.isAuthorized(['Admin']);
  }

  buynumbermanager() {
    this.router.navigate(['buynumber']);
  }

  gotoOrganization() {
    this.router.navigate(['/profile', this.organization.MemberId ]);
  }

  newEntity(what: string) {
    switch (what) {
      case "organization":
        this.router.navigate(['/organization', 0, 'smshomeorg']);
        break;
      case "key":
        this.router.navigate(['/securitykey', 0, 'smshomekey']);
        break;
      case "webook":
        this.router.navigate(['/webhook', 0, 'smshomewebhook']);
        break;
      case "keyword":
        this.router.navigate(['/keyword', 0, 'smshomekeyword']);
        break;
      case "key1":
        this.router.navigate(['/organization', 0, 'smshomeorg']);
        break;

    }
  }
}
